export function Nav() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-5 md:px-12">
        <a href="/" className="font-display text-xl tracking-mega text-bone">
          MIKAZURA
        </a>
        <nav className="hidden items-center gap-10 text-[11px] uppercase tracking-editorial text-muted-foreground md:flex">
          <a href="#aesthetics" className="transition-colors hover:text-bone">Aesthetics</a>
          <a href="#process" className="transition-colors hover:text-bone">Process</a>
          <a href="#gallery" className="transition-colors hover:text-bone">Gallery</a>
          <a href="#vision" className="transition-colors hover:text-bone">Vision</a>
        </nav>
        <a
          href="#book"
          className="group inline-flex items-center gap-2 border border-bone/30 px-4 py-2 text-[11px] uppercase tracking-editorial text-bone transition-all hover:border-bone hover:bg-bone hover:text-background"
        >
          Begin Shoot
          <span className="transition-transform group-hover:translate-x-0.5">→</span>
        </a>
      </div>
    </header>
  );
}
